import { memo } from "react";
import { Badge } from "@/ui/atoms";
import type { TFileStatus } from "@/store";

/**
 * Status to badge variant mapping
 */
const statusConfig: Record<
    string,
    {
        label: string;
        variant: "default" | "secondary" | "destructive" | "outline" | "success" | "warning";
    }
> = {
    not_received: { label: "Not Received", variant: "outline" },
    uploaded: { label: "Uploaded", variant: "secondary" },
    under_acceptance: { label: "Under Acceptance", variant: "warning" },
    under_review: { label: "Under Review", variant: "destructive" },
    ready_for_balancing: { label: "Ready for Balancing", variant: "success" },
    balanced: { label: "Balanced", variant: "success" },
    ready_for_commitment: { label: "Ready for Commitment", variant: "warning" },
    committed: { label: "Committed", variant: "success" },
    adjusted: { label: "Adjusted", variant: "success" },
    finjournal_generated: { label: "FinJournal Generated", variant: "success" },
    data_platform_generated: { label: "Data Platform Generated", variant: "success" },
    completed: { label: "Completed", variant: "default" },
    failed: { label: "Failed", variant: "destructive" },
    rejected: { label: "Rejected", variant: "destructive" },
};

export interface TStatusBadgeProps {
    status: TFileStatus;
    className?: string;
}

export const StatusBadge = memo(function StatusBadge({ status, className }: TStatusBadgeProps) {
    const config = statusConfig[status] || { label: status, variant: "outline" as const };

    return (
        <Badge variant={config.variant} className={className} data-testid="status-badge">
            {config.label}
        </Badge>
    );
});
